import BaseComponent from "components/base-component"
import classNames from "classnames"
import instanceOfClassName from "@kaspernj/api-maker/build/instance-of-class-name"
import Link from "@kaspernj/api-maker/build/link"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
export default class ComponentsEmailTemplatePreviewsLink extends BaseComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    emailTemplatePreview: instanceOfClassName("EmailTemplatePreview").isRequired,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {adminLayout, children, className, emailTemplatePreview, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--email-template-previews--link", className)
    const to = this.to()

    if (to) {
      return (
        <Link className={generatedClassName} to={to} {...restProps}>
          {children || emailTemplatePreview.name()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || emailTemplatePreview.name()}
      </span>
    )
  }

  to() {
    const {adminLayout, emailTemplatePreview} = this.p

    if (adminLayout) return Routes.adminEmailTemplatePreviewPath(emailTemplatePreview.emailTemplateId(), emailTemplatePreview.id())
  }
}
